import {
  makePaginationState,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';


const initialState = {
  blockedUsers: makePaginationState(),
};


export default (state = initialState, action) => {
  switch (action.type) {
    // fetch following users
    case `${t.FETCH_BLOCKED_USERS}_PENDING`:
      return {
        ...state,
        blockedUsers: {
          ...state.blockedUsers,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_BLOCKED_USERS}_SUCCESS`:
      return {
        ...state,
        blockedUsers: {
          ...state.blockedUsers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.blockedUsers.pagination.items
              .concat(action.payload.result.items),
          },
        },
      };
    case `${t.FETCH_BLOCKED_USERS}_ERROR`:
      return {
        ...state,
        blockedUsers: {
          ...state.blockedUsers,
          status: STATUSES.ERROR,
        },
      };

    case t.RESET_BLOCKED_USERS:
      return {
        ...state,
        blockedUsers: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/blockedUserList/reducer.js